import React from "react";

import Card from "@material-ui/core/Card";
import {Grid} from "@material-ui/core";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import * as Constants from "../../../../consts/Constants.js";
import Box from "@mui/material/Box";

export default function AppointmentItem({
    appointment,
    select
}) {

    const [disable, setDisable] = React.useState(false);

    const getStatusName = () => {
        switch (appointment.state) {
            case "CREATED":
                return "Pendiente";
            case "CONFIRMED":
                return "Planificada";
            case "REJECTED":
                return "Rechazado";
            case "CANCELED":
                return "Cancelado";
            case "SUCCESSFULLY_ATTENDED":
                return "Atendido";
            case "UNSUCCESSFULLY_ATTENDED":
                return "Fallido";
            default:
                return "Desconocido";
        }
    }

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Card style={{textAlign: 'left', marginBottom: 8}}>
                    <Grid container spacing={2}>
                        <Grid item xs={true}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={true}>
                                            <Grid container>
                                                <Grid item style={{background: Constants.COLOR_GRAY}}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        height="100%">
                                                        <Card elevation={0} style={{
                                                            background: Constants.COLOR_GRAY,
                                                            padding: '8px',
                                                            width: 90,
                                                            textAlign: 'center'
                                                        }}>
                                                            <b style={{color: 'white'}}>#{appointment.id}</b>
                                                        </Card>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={true}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="left"
                                                        alignItems="center"
                                                        style={{paddingLeft: 8}}
                                                        height="100%">
                                                          <span>
                                                              <b>{appointment.location.address}</b> - {appointment.contactInformation.name}{appointment.contactInformation.phoneNumber ? " (" + appointment.contactInformation.phoneNumber + ")" : ""}
                                                          </span>
                                                    </Box>
                                                </Grid>
                                                <Grid item>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="left"
                                                        alignItems="center"
                                                        style={{padding: 2}}
                                                        height="100%">
                                                        <span>
                                                           { getStatusName() }
                                                        </span>
                                                    </Box>
                                                </Grid>
                                                <Grid item>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="left"
                                                        alignItems="center"
                                                        style={{padding: 2}}
                                                        height="100%">
                                                        <Tooltip title="Abrir">
                                                            <span>
                                                                <IconButton disabled={disable} onClick={() => { select(appointment) }}>
                                                                    <OpenInNewIcon fontSize="small"/>
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
        </Grid>
    );
}